import { lazy } from "react";
import { LinkTo } from "shared/constants/linkTo";

const BookChapterCreate = lazy(() => import('_deziiign/books/pages/BookChapterCreate'));
const BookEdit = lazy(() => import('_deziiign/books/pages/BookEdit'));
const BookListView = lazy(() => import('_deziiign/books/pages/BookListView'));
const MyBooksPage = lazy(() => import("shared/pages/MyBooks/MyBooksPage"));
const ProjectEditPage = lazy(() => import("shared/pages/projectEdit"));
const ProjectPageNew = lazy(() => import("shared/pages/project"));
const TagBookListView = lazy(() => import('_deziiign/books/pages/tag'));
const TagCategoryView = lazy(() => import('shared/pages/tagCategoryView'));

const bookRoutes = [
    { path: LinkTo.bookProjectCreate, exact: true, isPrivate: true, component: BookChapterCreate },
    { path: LinkTo.book, exact: true, component: ProjectPageNew },
    { path: LinkTo.bookPreview, exact: true, component: ProjectPageNew },
    { path: LinkTo.myBooks, exact: true, isPrivate: true, component: MyBooksPage },
    { path: LinkTo.bookEdit, exact: true, isPrivate: true, component: BookEdit },
    { path: LinkTo.bookCreate, exact: true, isPrivate: true, component: BookEdit },
    { path: "/books" + LinkTo.project, exact: true, component: ProjectPageNew },
    { path: "/books" + LinkTo.preview, exact: true, component: ProjectPageNew },
    { path: "/books" + LinkTo.projectEdit, exact: true, isPrivate: true, component: ProjectEditPage },
    { path: "/books" + LinkTo.bookProjectCreate, exact: true, isPrivate: true, component: BookChapterCreate },
    { path: "/books" + LinkTo.book, exact: true, component: ProjectPageNew },
    { path: "/books" + LinkTo.bookPreview, exact: true, component: ProjectPageNew },
    { path: "/books" + LinkTo.bookEdit, exact: true, isPrivate: true, component: BookEdit },
    { path: "/books" + LinkTo.bookCreate, exact: true, isPrivate: true, component: BookEdit },
    { path: "/books" + LinkTo.tagCategory, exact: true, component: TagCategoryView },
    { path: "/books" + LinkTo.tag, exact: true, component: () => <TagBookListView className="witeTheme"/> },
    { path: '/books/create', exact: true, component: BookListView },
];

export default bookRoutes;import { lazy } from "react";
import { LinkTo } from "shared/constants/linkTo";

const BookChapterCreate = lazy(() => import('_deziiign/books/pages/BookChapterCreate'));
const BookEdit = lazy(() => import('_deziiign/books/pages/BookEdit'));
const BookListView = lazy(() => import('_deziiign/books/pages/BookListView'));
const MyBooksPage = lazy(() => import("shared/pages/MyBooks/MyBooksPage"));
const ProjectEditPage = lazy(() => import("shared/pages/projectEdit"));
const ProjectPageNew = lazy(() => import("shared/pages/project"));
const TagBookListView = lazy(() => import('_deziiign/books/pages/tag'));
const TagCategoryView = lazy(() => import('shared/pages/tagCategoryView'));

const bookRoutes = [
    { path: LinkTo.bookProjectCreate, exact: true, isPrivate: true, component: BookChapterCreate },
    { path: LinkTo.book, exact: true, component: ProjectPageNew },
    { path: LinkTo.bookPreview, exact: true, component: ProjectPageNew },
    { path: LinkTo.myBooks, exact: true, isPrivate: true, component: MyBooksPage },
    { path: LinkTo.bookEdit, exact: true, isPrivate: true, component: BookEdit },
    { path: LinkTo.bookCreate, exact: true, isPrivate: true, component: BookEdit },
    { path: "/books" + LinkTo.project, exact: true, component: ProjectPageNew },
    { path: "/books" + LinkTo.preview, exact: true, component: ProjectPageNew },
    { path: "/books" + LinkTo.projectEdit, exact: true, isPrivate: true, component: ProjectEditPage },
    { path: "/books" + LinkTo.bookProjectCreate, exact: true, isPrivate: true, component: BookChapterCreate },
    { path: "/books" + LinkTo.book, exact: true, component: ProjectPageNew },
    { path: "/books" + LinkTo.bookPreview, exact: true, component: ProjectPageNew },
    { path: "/books" + LinkTo.bookEdit, exact: true, isPrivate: true, component: BookEdit },
    { path: "/books" + LinkTo.bookCreate, exact: true, isPrivate: true, component: BookEdit },
    { path: "/books" + LinkTo.tagCategory, exact: true, component: TagCategoryView },
    { path: "/books" + LinkTo.tag, exact: true, component: () => <TagBookListView className="witeTheme"/> },
    { path: '/books/create', exact: true, component: BookListView },
];

export default bookRoutes;